import { Button, Container, Nav, Navbar } from "react-bootstrap";

const Header = () => {

    return (
        <>
            <header className="header">
                <Navbar expand="lg">
                    <Container>
                        <Navbar.Brand href="#home"><img src={require("../assets/images/Logo.png")} alt="img" className="light-logo" /> <img src={require("../assets/images/footer-logo.png")} className="dark-logo" alt="img" /></Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto">
                                <Nav.Link href="#home">Home</Nav.Link>
                                <Nav.Link href="#burnout-problem">Burnout Problem</Nav.Link>
                                <Nav.Link href="#about-us">About Us</Nav.Link>
                                <Nav.Link href="#solution">Solution</Nav.Link>
                                <Nav.Link href="#roi-main-calculator">ROI Calculator</Nav.Link>
                                <Nav.Link href="#pricing">Pricing</Nav.Link>
                                <Nav.Link href="#contact-us" ><Button className="get-started-btn">Contact Us</Button></Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </header>

        </>
    )
};
export default Header;